import React from 'react'

import { TimeframeBar } from '../../components'
import { SpecificChartFunctionality, TIMEFRAME } from '../../constants/common'
import { useModelState } from '../../model-hooks/use-model-state'
import { useChartLayoutGlobalModel } from '../chart-settings'
import { CustomDateRange } from './custom-date-range'
import { useChartControls } from './use-chart-controls'
import { useFavoriteTimeframes } from './use-favorite-timeframes'
import { useTimeframeDateRangeGroups } from './use-timeframe-date-range-groups'

export function StockDetailTimeframeBar({
  isDateRangeAvailable,
  isPremium,
  isLoadingOverride,
}: {
  isDateRangeAvailable: boolean
  isPremium: boolean
  isLoadingOverride?: boolean
}) {
  const { chartLayoutModel } = useChartLayoutGlobalModel()
  const chartModelUnwatched = React.useMemo(() => chartLayoutModel?.getAllCharts()[0] ?? null, [chartLayoutModel])
  const { favoriteTimeframes, toggleFavoriteTimeframe } = useFavoriteTimeframes(isPremium)
  const chartModel = useModelState(chartModelUnwatched, {
    watchProperties: ['timeframe', 'dateRange'],
  })
  const { isLoading } = useChartControls({
    chartModel,
    isInteractive: isDateRangeAvailable,
  })
  const { customDateRangeDialogState, handleDateRangeSelect, dateRangeGroups, timeFrameGroups } =
    useTimeframeDateRangeGroups({
      isPremium: window.FinvizSettings.hasUserPremium,
      chartModel,
      specificChartFunctionality: SpecificChartFunctionality.quotePage,
    })

  return (
    <>
      <TimeframeBar
        size="regular"
        chartIndex={0}
        rounding="none"
        timeFrameGroups={timeFrameGroups}
        dateRangeGroups={dateRangeGroups}
        selectedTimeframe={chartModel?.timeframe}
        selectedDateRange={chartModel?.dateRange}
        favoriteTimeframes={favoriteTimeframes}
        loadingTimeframe={isLoadingOverride ?? isLoading ? chartModel?.timeframe : undefined}
        onDateRangeSelect={handleDateRangeSelect}
        onTimeframeSelect={() => {}}
        onFavoriteTimeframeToggle={({ value }: { value: TIMEFRAME }) => {
          toggleFavoriteTimeframe(value)
        }}
        isDateRangeAvailable={isDateRangeAvailable}
        containerElement={document.body}
        className="!m-0"
        isFavoritesEnabled={isPremium}
        isScrollIntoViewEnabled={false}
      />

      <CustomDateRange
        dialogState={customDateRangeDialogState}
        onSave={handleDateRangeSelect}
        chartModel={chartModel}
      />
    </>
  )
}
